module.exports = __webpack_public_path__ + "static/media/Artboard16.1d2870d9.png";